<template>
  <div class="product-detail-page-7">
    <!-- 商品总的描述 -->
    <div class="top-section flex-between">
      <!-- 左边主要内容 -->
      <div class="left-content flex-rowl">
        <div class="image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/10/5549456103765524208.jpg?v=01"
            class="zoomable-image"
          />
        </div>
        <div class="text-content">
          <h1 class="title">{{ $t('productDetail7.title') }}</h1>
          <h2 class="sub_title">{{ $t('productDetail7.subTitle') }}</h2>
          <div class="description">
            <p class="txt2 mb_40">
               {{ $t('productDetail7.description.para1') }}
            </p>
            <p class="txt2 mb_40" v-html=" $t('productDetail7.description.para2') ">
            </p>
            <p class="txt2 mb_40" v-html="$t('productDetail7.description.para3')"></p>
            <p class="txt1 mb_30">{{ $t('productDetail7.description.usageTitle') }}</p>
            <p class="txt2" v-html="$t('productDetail7.description.usageContent')"></p>
          </div>
          <div
            class="more-details-wrap"
            @mouseenter="showQRCode = true"
            @mouseleave="showQRCode = false"
          >
            <button class="more-details-btn flex-rowl">
              {{ $t('productDetail7.consultationButton') }}
              <i class="iconfont icon-xiangxiajiantou"></i>
            </button>
            <div class="more-details-ercode flex-colc" v-show="showQRCode">
              <div class="ercode_img">
                <img
                  src="https://upload.vwingist.com/melscn/0image/2025/05/4712686608098036872.png"
                  alt=""
                />
              </div>
              <div class="ercode_txt flex-colc">
                <p v-html="$t('productDetail7.qrCodeInfo.text1') "></p>
                <p v-html="$t('productDetail7.qrCodeInfo.text2')"></p>
                <p v-html="$t('productDetail7.qrCodeInfo.text3')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边商品分类折叠面板 -->
      <ProductCategoryPanel />
    </div>
    <!-- 商品详细描述 -->
    <div class="bottom-section">
      <div
        v-for="(item, index) in detailItems"
        :key="index"
        :class="[
          'bottom-section-list flex-between',
          item.length == 2 ? 'new-class-2' : '',
          item.length == 3 ? 'new-class-3' : '',
        ]"
      >
        <div
          class="detail-item"
          v-for="(itemChild, indexChild) in item"
          :key="indexChild"
        >
          <div class="top-part flex-between">
            <div class="left-text">
              <h2 class="sub-title">{{ $t(`productDetail7.detailItems[${indexChild}].subTitle`)}}</h2>
              <!-- <h2 class="sub-title">{{ itemChild.subTitle }}</h2> -->
              <p class="sub-description">{{ $t(`productDetail7.detailItems[${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img :src="itemChild.imageUrl" class="zoomable-image" />
            </div>
          </div>
          <div class="bottom-list">
            <div
              class="bottom-item"
              v-for="(itemChild1, indexChild1) in itemChild.detailList"
              :key="indexChild1"
            >
              <h2 class="sub-title">{{ $t(`productDetail7.detailItems[${indexChild}].detailList[${indexChild1}].subTitle`) }}</h2>
              <p class="sub-description">{{ $t(`productDetail7.detailItems[${indexChild}].detailList[${indexChild1}].subDescription`) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategoryPanel from "@/components/ProductCategoryPanel.vue";

export default {
  name: "ProductDetail1",
  components: {
    ProductCategoryPanel,
  },
  data() {
    return {
      showQRCode: false,
      detailItems: [
        [
          {
            subTitle: "山茶籽油精粹",
            subDescription: "大自然的神奇力量",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5151677266311640651.png",
            detailTitle: "",
            detailDescription: "",
            detailList: [
              {
                subTitle: "高親膚性",
                subDescription:
                  "富含類人體皮脂膜油酸，長效鎖水保濕，讓肌肉膚時保持水潤光澤。",
              },
              {
                subTitle: "抗氧化",
                subDescription:
                  "角鯊烯成分，抵禦光老化，減少皺紋，延緩衰老，讓肌膚煥發年輕活力。",
              },
              {
                subTitle: "提亮膚色",
                subDescription:
                  "茶多酚抑制黑色素活性，淡化色素，讓肌膚自然透亮。",
              },
            ],
          },
          {
            subTitle: "内外兼修",
            subDescription: "肌膚自由呼吸",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5634343396824201242.png",
            detailTitle: "",
            detailDescription: "",
            detailList: [
              {
                subTitle: "對外保護",
                subDescription: "隔絕粉塵氧化，保護肌膚免受外界侵害。",
              },
              {
                subTitle: "對內透氣",
                subDescription: "隔絕粉壓，讓肌膚自由呼吸，保持清透無瑕。",
              },
            ],
          },
          {
            subTitle: "持久守護",
            subDescription: "打造全天候的美麗",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5547984655072978636.png",
            detailTitle: "",
            detailDescription: "",
            detailList: [
              {
                subTitle: "智慧反射技術",
                subDescription:
                  "高效能遮瑕，均勻膚色，提昇亮度，讓你在任何光線下都能展現自然光澤。",
              },
              {
                subTitle: "24小時持久",
                subDescription:
                  "天然油脂24小時長效持妝，溫和穩定，不論是辦公室還是夜晚派對，你的妝容都能持久如新。",
              },
            ],
          },
        ],
      ],
    };
  },
};
</script>

<style scoped lang="less">
.product-detail-page-7 {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .top-section {
    margin-bottom: 120px;
    align-items: flex-start;
    .left-content {
      width: 985px;
      flex-shrink: 0;
      align-items: flex-start;
      .image-container {
        width: 389px;
        height: 613px;
        margin-right: 50px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text-content {
        flex: 1;
        color: #333333;
        .title {
          font-size: 26px;
          margin-bottom: 10px;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          font-weight: 600;
        }
        .sub_title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .description {
          .txt1 {
            font-size: 20px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .txt2 {
            font-size: 18px;
            line-height: 30px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
          .mb_30 {
            margin-bottom: 30px;
          }
          .mb_40 {
            margin-bottom: 40px;
          }
        }

        .more-details-btn {
          width: 359px;
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          border: 2px solid #000000;
          font-size: 16px;
          color: #000000;
          margin-top: 50px;
          cursor: pointer;
          position: relative;
          padding-left: 30px;
          box-sizing: border-box;
          background-color: #fff;
          .icon-xiangxiajiantou {
            position: absolute;
            right: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-section {
    .bottom-section-list {
      align-items: flex-start;
      &.new-class-2 {
        padding-left: 110px;
        padding-right: 110px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 2);
        }
      }
      &.new-class-3 {
        margin-bottom: 100px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 3);
        }
      }
      .detail-item {
        padding-right: 47px;
        box-sizing: border-box;
        border-right: 1px dashed #999999;
        &:last-child {
          border-right: none;
        }
        .top-part {
          width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          .left-text {
            color: #333333;
            flex: 1;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            // border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .bottom-part {
          color: #333333;
          .detail-title {
            font-size: 24px;
            line-height: 34px;
            margin-bottom: 30px;
          }
          .detail-description {
            font-size: 16px;
            line-height: 28px;
          }
        }
        .bottom-list {
          .bottom-item {
            margin-bottom: 50px;
            color: #000000;
            &:last-child {
              margin-bottom: 0;
            }
            .sub-title {
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              font-size: 24px;
              margin-bottom: 24px;
              position: relative;
              padding-left: 26px;
              box-sizing: border-box;
              &::before {
                width: 8px;
                height: 8px;
                background: #333333;
                border-radius: 50%;
                display: inline-block;
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
              }
            }
            .sub-description {
              font-size: 16px;
              font-family: "SourceHanSerifCN-Light", sans-serif;
              line-height: 29px;
            }
          }
        }
      }
    }
  }

  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 378px;
      height: 408px;
      background: url(https://upload.vwingist.com/melscn/0image/2025/04/5425508493632964248.png)
        no-repeat center;
      background-size: cover;
      position: absolute;
      bottom: -9px;
      left: 340px;
      z-index: 9999;
      .ercode_img {
        width: 230px;
        height: 230px;
        margin-bottom: 38px;
      }
      .ercode_txt {
        font-size: 16px;
        color: #333333;
        p {
          margin-bottom: 10px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-family: "SourceHanSansCN-Medium", sans-serif;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>